import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBox = styled(Box)<BoxProps>({
  '.topRight': {
    marginTop: '70px',
  },
});
